<div class="portal-toolbar">
  <div class="portal-toolbar__left">
    <ng-content select="[portalToolbarLeft]"></ng-content>
  </div>
  <div class="portal-toolbar__right">
    <ng-content select="[portalToolbarRight]"></ng-content>
  </div>
</div>
